<script lang="ts">
import { defineComponent } from "vue";
import _ from "@/boot/lodash";
import type { RenderContext } from "vue";

export default defineComponent({
  functional: true,
  render(h, context: RenderContext) {
    const scopedSlots = ["A", "B"];
    const slots = _.keyBy(context.children, "data.slot") as object;
    return h(
      "div",
      _.set(context.data, "[class][bermuda-columns]", true),
      _.map(
        _.filter(scopedSlots, key => slots[key]),
        (key: string) => {
          const slot = slots[key];
          return h(
            "div",
            _.set(slot.data, `[class][column-slot-${key.toLowerCase()}]`, true),
            slot.children
          );
        }
      )
    );
  }
});
</script>

<style lang="scss" scoped>
$gap: 1rem;
.bermuda-columns {
  display: flex;
  flex-wrap: wrap;
  &.is-reversed {
    .column-slot-a {
      order: 2;
    }
    .column-slot-b {
      order: 1;
    }
  }
  margin-top: -$gap;
  margin-left: -$gap;
  margin-right: -$gap;
  .column-slot-a,
  .column-slot-b {
    max-width: 100%;
    padding: $gap;
  }
  .column-slot-a {
    width: 20rem;
    flex-grow: 1;
  }
  .column-slot-b {
    width: 38rem;
    flex-grow: 999999;
  }
}
</style>
